/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState } from "react";
import { TooltipStyle } from './style';
import { CustomIcon } from 'datastake-daf/dist/components';
import { useTranslation } from "react-i18next";

const Tooltip = ({
  mouseY = 0,
  mouseX = 0,
  label = null,
  setHoveredGroup,
  hoveredGroup,
  src = '',
  showSources = true,
}) => {
  const { t } = useTranslation();
  const [mouseEnteredTooltip, setMouseEnteredTooltip] = useState(false);

  const onMouseEnterHandler = useCallback(() => {
    if (!mouseEnteredTooltip) {
      setHoveredGroup(hoveredGroup);
      setMouseEnteredTooltip(true);
    }
  }, [mouseEnteredTooltip, hoveredGroup]);

  const onMouseLeaveHandler = useCallback(() => {
    setHoveredGroup(null);
    setMouseEnteredTooltip(false);
  }, []);

  const events = hoveredGroup.associatedWith;
  const sources = 1;

  const value = hoveredGroup.title ? (hoveredGroup.title.split('SDG ')[1]) : '';

  return (
    <TooltipStyle
      style={{ top: mouseY, left: mouseX }}
      onMouseEnter={onMouseEnterHandler}
      onMouseLeave={onMouseLeaveHandler}
    >
      <div className="tooltip-header">
        <div>
          <div className="identifier" style={{ background: hoveredGroup.color }}>
            <img src={src} alt="icon" />
          </div>
        </div>
        <div className="content-main">
          <h6>
            {t('SDG')}
            {' '}
            {value}
          </h6>
        </div>
      </div>
      <div className="tooltip-body">
        <p>{label ? t(label) : null}</p>
      </div>
      <div className="tooltip-bottom" style={{ color: hoveredGroup.color }}>
        <div className="item">
          <CustomIcon name="Event" width={15} height={13} />
          <label>
            {events}
            {' '}
            {t(events === 1 ? 'Event' : 'Events')}
          </label>
        </div>
        {showSources && (
          <div className="item">
            <CustomIcon name="Source" width={15} height={13} />
            <label>
              {sources}
              {' '}
              {t(sources === 1 ? 'Source' : 'Sources')}
            </label>
          </div>
        )}
      </div>
    </TooltipStyle>
  );
};

export default Tooltip;
